<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar">
                  <div>
                    <h4 class="text-primary">Product Journal Sales Check</h4>
                    <div class="form-inline">
                        <div class="button-group ml-1">
                            <span class="mr-1"><b>Date:</b> </span>
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                        </div>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-body">
                      <div class="table-responsive">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#product-sales-check" data-toggle="tab" aria-expanded="false" class="nav-link active">Data</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="product-sales-check">
                              <div class="table-responsive">
                                <div class="form-inline ml-auto">
                                  <div class="button-group">
                                    <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                      <i class="fa fa-filter" aria-hidden="true"></i> Filter <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu p-2" >
                                      <span>Etc:</span>
                                      <div class="dropdown-divider"></div>
                                      <li>
                                        <a href="javascript:void(0)" class="small" tabIndex="-1">
                                          <input type="checkbox" value="true" v-model="filterDiff"/>&nbsp; Diff Account {{ filterDiff }}</a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <tr>
                                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                          {{ t.name }}
                                          <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                        </th>
                                        <th>#</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(d, index) in filterData" :key="index">
                                      <td><b>[{{ d.product_no }}]</b> {{ d.product_name }}</td>
                                      <td>{{ d.type_code_persediaan }}</td>
                                      <td>
                                        <span class="badge badge-danger" v-if="d.type_code_persediaan !== d.sale_code_account">{{ d.sale_code_account }}</span>
                                        <span v-else>{{ d.sale_code_account }}</span>
                                      </td>
                                      <td>{{ d.sale_no }}</td>
                                      <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>
                                        <button type="button" class="btn btn-sm btn-hard-primary" @click="setJournalStockSingle(d.sale_id)">
                                          <i class="fa fa-refresh"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"><pre>{{ dataRaw }}</pre></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { salesUrl, productUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'ProductJournalSalesCheck',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterDiff: false,
      uom: null,
      company_no: null,
      product_no: null,
      filterCompany: [],
      startDate: [date1, date2],
      dateNow: new Date(),
      company: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Product',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Type Account',
        prop: 'type_code_persediaan',
        align: 'text-left'
      }, {
        name: 'Sales Account',
        prop: 'sale_code_account',
        align: 'text-left'
      }, {
        name: 'Sales No.',
        prop: 'sale_no',
        align: 'text-left'
      }, {
        name: 'Sales Date',
        prop: 'sale_date',
        align: 'text-left'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    companyData () {
      var obj = {
        name: null,
        address: null,
        phone: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address,
          phone: cmp.phone
        }
      }
      return obj
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterDiff === true) {
          if (d.type_code_persediaan !== d.sale_code_account) {
            return d
          }
        } else {
          return d
        }
      })
    }
  },
  methods: {
    async setJournalStockSingle (id) {
      await this.$Progress.start()
      this.loader.isLoading = true
      await axios.get(salesUrl + '/journal/' + id, { headers: getHeader() })
        .then(response => {
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await axios.get(salesUrl + '/journal-stock-out/' + id, { headers: getHeader() })
        .then(response => {
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success journal product sales', 'success')
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      await axios.post(productUrl + '/sales-journal-check', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.raw
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.message, 'error')
          throw error
        })
    }
  }
}
</script>
